import useGetOfferFeatures from './useGetOfferFeatures'

export default useGetOfferFeatures
